import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { Icon } from "components/ShellV2";

/* rec-styled standalone pager (same markup as the DataTable footer pager),
   for paginating arbitrary content like card grids. */
function Pager({ page, pages, onChange }) {
  const { t } = useTranslation(["common"]);
  const safePage = Math.min(page, pages);

  if (pages <= 1) return null;

  return (
    <div className="rec-pager">
      <button
        type="button"
        disabled={safePage === 1}
        onClick={() => onChange(1)}
        aria-label={t("table.first_page", { defaultValue: "Primeira página" })}
      >
        <Icon name="first_page" style={{ fontSize: 18 }} />
      </button>
      <button
        type="button"
        disabled={safePage === 1}
        onClick={() => onChange(Math.max(1, safePage - 1))}
        aria-label={t("table.prev_page", { defaultValue: "Anterior" })}
      >
        <Icon name="chevron_left" style={{ fontSize: 18 }} />
      </button>
      {Array.from({ length: Math.min(pages, 5) }).map((_, i) => {
        const base = Math.min(Math.max(1, safePage - 2), Math.max(1, pages - 4));
        const n = base + i;
        return n <= pages ? (
          <button
            key={n}
            type="button"
            className={safePage === n ? "on" : ""}
            onClick={() => onChange(n)}
          >
            {n}
          </button>
        ) : null;
      })}
      <button
        type="button"
        disabled={safePage === pages}
        onClick={() => onChange(Math.min(pages, safePage + 1))}
        aria-label={t("table.next_page", { defaultValue: "Seguinte" })}
      >
        <Icon name="chevron_right" style={{ fontSize: 18 }} />
      </button>
      <button
        type="button"
        disabled={safePage === pages}
        onClick={() => onChange(pages)}
        aria-label={t("table.last_page", { defaultValue: "Última página" })}
      >
        <Icon name="last_page" style={{ fontSize: 18 }} />
      </button>
    </div>
  );
}

Pager.propTypes = {
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Pager;
